routes.$inject = ['$stateProvider'];

var templateProfile = require('./templates/profile.html');
var templateDetails = require('./templates/details.html');
var templateBilling = require('./templates/billing.html');
var templateTransaction = require('./templates/transaction.html');
var templateTraining = require('./templates/training.html');
var templateDocumentation = require('./templates/documentation.html');

export default function routes($stateProvider) {
  $stateProvider
    .state('app.pharmacist', {
      url: '/profile',
      templateUrl: templateProfile,
      controller: 'PharmacistController',
      controllerAs: 'pharmacistCtrl',
      params: {
        bodyClasses: 'profile'
      }
    })
    .state('app.pharmacist.details', {
      url: '/details',
      templateUrl: templateDetails,
      controller: 'DetailsController',
      controllerAs: 'detailsCtrl',
      title: 'Details',
      params: {
        bodyClasses: 'profile'
      }
    })
    .state('app.pharmacist.billing', {
      url: '/billing',
      templateUrl: templateBilling,
      controller: 'BillingController',
      controllerAs: 'billingCtrl',
      title: 'Billing',
      params: {
        bodyClasses: 'profile'
      }
    })
    .state('app.pharmacist.transaction', {
      url: '/transaction',
      templateUrl: templateTransaction,
      controller: 'TransactionController',
      controllerAs: 'transactionCtrl',
      title: 'Transaction History',
      params: {
        bodyClasses: 'profile'
      }
    })
    .state('app.pharmacist.training', {
      url: '/training',
      templateUrl: templateTraining,
      resolve: {
        training_video: function (TrainingService) {
          return TrainingService.load_video_duration();
        },
      },
      controller: 'TrainingController',
      controllerAs: 'trainingCtrl',
      title: 'Training',
      params: {
        bodyClasses: 'profile'
      }
    })
    .state('app.pharmacist.documentation', {
      url: '/documentation',
      templateUrl: templateDocumentation,
      controller: 'DocumentationController',
      controllerAs: 'documentationCtrl',
      title: 'Documentation',
      params: {
        bodyClasses: 'profile'
      }
    })
  ;
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/pharmacist.routes.js
 **/